import firebase from 'firebase'

export const setUserListener = (userID) => (dispatch, getState) => {
  dispatch({type: 'data_requested_user' })
  firebase.database().ref('users').child(userID).on('value', snap => {
    dispatch({ type: 'value_received_user' , payload: snap.val() })
  })
}



// WEBPACK FOOTER //
// ./src/actions/listeners/user.js